module.exports = __webpack_public_path__ + "img/dark-lock-ill.10bbaea1.png";